import { AimsCommonPopupEditorComponent } from '@aims/common-components';
import { Component, Input, EventEmitter, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import * as moment from 'moment-mini';
import { take } from 'rxjs/operators';
import { TransferHttpService } from 'src/app/services/transfer-http/transfer-http.service';
import { SanComponent } from '../san/san.component';
import { DayOfMonth, ScheduledResource } from './aims-scheduler.classes';

export const Gender = {
  m: "M",
  f: "F",
  g: "CNTI"
}

@Component({
  selector: 'aims-scheduler-calendarview',
  styleUrls: ['./aims-scheduler.component.css'],
  templateUrl: './aims-scheduler-calendarview.component.html',
  exportAs: 'schedulerCalendarView'
})
export class AimsSchedulerCalendarViewComponent {

  constructor(private dialog: MatDialog,
              private transferHttp: TransferHttpService) { }

  private _data: Array<DayOfMonth>;
  @Input() set data(value: Array<DayOfMonth>) {
    this._data = value;
    this.currentlySelectedDay = undefined;
  }

  get data(): Array<DayOfMonth> {
    return this._data;
  }

  //daysToDisplay: Array<DayOfMonth> = [];
  currentlySelectedDay: DayOfMonth;

  @Output() daySelected = new EventEmitter<Array<DayOfMonth>>();

  public sanDayAndItems: SanDayAndItems;

  //***************************
  // Widget Actions
  //***************************

  flightsScheduled(day: DayOfMonth) {
    return day.scheduled.filter(s => s.isCarrier);
  }

  returnDayNum(day: DayOfMonth): number {
    return <number>day.day.day();
  }

  private compareTo(val1, val2, typeField) {
    let result = 0;
    if (typeField == "ftDate") {
      result = val1 - val2;
    } else {
      if (val1 < val2) {
        result = - 1;
      } else if (val1 > val2) {
        result = 1;
      } else {
        result = 0;
      }
    }

    return result;
  }

  displaySAN_SDN(day: DayOfMonth) {
    this.sanDayAndItems = new SanDayAndItems();
    this.sanDayAndItems.items = day.scheduled.filter(s => s.siteArrivalNoticeRequired &&
      (
        day.day.isSame(moment(s.start), 'day') || day.day.isSame(moment(s.end), 'day')
      )
    );
    this.sanDayAndItems.day = day.day;
    this.sanDayAndItems.items.sort((a, b) => {
      let cols = ["siteCode", "name"];
      let i = 0, result = 0, resultordem = 0;
      while (result === 0 && i < cols.length) {
        let col = cols[i];
        let valcol1 = a[col];
        let valcol2 = b[col];
        let typeField = "string";
        if (valcol1 != "null" && valcol1 != "null") {
          resultordem = this.compareTo(valcol1, valcol2, typeField);

          if (resultordem != 0) {
            break;
          }
        }
        i++;
      }

      return resultordem;
    });

    // open SAN dialog
    this.openSANPopup(this.sanDayAndItems);
  }

  public openSANPopup(sdi: SanDayAndItems) {
    const dialogRef = this.dialog.open(AimsCommonPopupEditorComponent, {
            width: '500px',
            data: {
                header: 'Site Arrivals and Departures',
                content: SanComponent,
                contentData: { sdi: sdi },
            },
            disableClose: true
        });

        dialogRef.afterClosed().subscribe(dialogResult => {
          if (dialogResult) {
            this.schSaveHandler(sdi);
          }
        });
  }

  schSaveHandler(sdi: SanDayAndItems) {
    let itemArr = [];
    sdi.items.forEach(i => itemArr.push({ id: i.id, confirmArrival: i.confirmArrival, confirmDeparture: i.confirmDeparture, notes: i.notes }))
    this.transferHttp.post('Sch/UpdateSan', itemArr).pipe(take(1)).subscribe(_ => { });
  }

  isSelected(day: moment.Moment) {
    if (this.currentlySelectedDay !== undefined && this.currentlySelectedDay.day.isSame(day, 'day')) {
      return true;
    }
    return false;
  }

  clickDay(dayOfMonth: DayOfMonth) {
    if (this.currentlySelectedDay === undefined || !dayOfMonth.day.isSame(this.currentlySelectedDay.day, 'day')) {
      this.currentlySelectedDay = dayOfMonth;
      this.daySelected.emit([dayOfMonth]);
    }
    else {
      this.currentlySelectedDay = undefined;
      this.daySelected.emit(null);
    }
  }

  ngOnInit() {
  }

}

export class SanDayAndItems {
  day: moment.Moment;
  items: Array<ScheduledResource>;
}



